// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1m95c","dragIcon":"Choice_dragIcon__2fKfa","left":"Choice_left__uAMuT","input":"Choice_input__3ivWD"};